import {Component, Input, Optional} from '@angular/core';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';
import {Translatable, TranslationService} from '@ngmedax/translation';
import {TRANSLATION_EDITOR_SCOPE} from '../../../../constants';
import {KEYS} from '../../../../translation-keys';

export interface MultiValuePreviewComponent extends Translatable {}

@Component({
  selector: 'app-qa-multi-value-preview',
  templateUrl: './multi-value-preview.component.html',
  styleUrls: ['./multi-value-preview.component.css']
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class MultiValuePreviewComponent {
  @Input() question: Questionnaire.Container;
  @Input() locale = 'de_DE';

  constructor(@Optional() private translationService: TranslationService) {}

  public fieldTypeLabel(field: Questionnaire.Container): string {
    const keys = {text: KEYS.EDITOR.FREE_TEXT, numeric: KEYS.EDITOR.NUMBER,
      date: KEYS.EDITOR.DATE, singleChoice: KEYS.EDITOR.DROPDOWN};
    return this._(keys[field.format] || KEYS.EDITOR.FREE_TEXT);
  }

  public fieldWidth(field: Questionnaire.Container): number {
    if (field.options?.widthPercent > 0) {
      return field.options.widthPercent;
    }
    const fields = this.question.elements || [];
    const automatic = fields.filter(item => !(item.options?.widthPercent > 0));
    const used = fields.reduce((sum, item) => sum + (item.options?.widthPercent || 0), 0);
    // Keep automatic columns visible even if the configured widths use all space.
    return Math.max(1, (100 - used) / Math.max(1, automatic.length));
  }
}
